import React, { useState, useEffect, useContext } from "react";
import {
  Row,
  Container,
  Card,
  CardBody,
  Col,
  Table,
  Button,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { taxTypes } from "../../../utils/constants"
// Pages
import Breadcrumbs from "../../../components/common/Breadcrumb";
import {
    handleAddEditTaxationApi,
    getAllTaxationDetailsApi,
    handleChangeTaxationStatusApi,
    fetchSingleTaxationsDetailsApi
} from "../../../api/taxationsApi";

import { AuthContext } from "../../../contexts/AuthContext";
import { useAppSettings } from '../../../contexts/AppSettingsContext';

function Taxations() {
  const { appSettings, setAppSettings } = useAppSettings();
  const appName = appSettings?.title ||process.env.REACT_APP_APP_NAME;
  const [taxationModal, setTaxationModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [taxations, setTaxations] = useState([]);
  const [popUpMode, setPopUpMode] = useState("");
  const [singleTaxationDetails, setSingleTaxationDetails] = useState({});
  const { authToken } = useContext(AuthContext);


  // Set token
  useEffect(() => {
    if (authToken) {
      fetchAllTaxations();
    }
  }, [authToken]);

  // Function handle open & close modal
  const toggle = () => {
    setTaxationModal(!taxationModal);
    if (!taxationModal) {
      // # Reset form to initial values when modal is closed
      taxationForm.resetForm();
      setErrorMessage("");
      setSuccessMessage("");
      setSingleTaxationDetails({});
      setPopUpMode("");
    }
  };

  // #Handle customer form
  const taxationForm = useFormik({
    enableReinitialize : true,
    initialValues: {
      name: singleTaxationDetails?.name || "",
    },
    onSubmit: (values) => {

      // Trim all string values
      const trimmedValues =  Object.keys(values).reduce((acc, key)=>{
          acc[key]  = typeof values[key] == 'string' ? values[key].trim() : values[key]  
          return acc
      },{})
      trimmedValues.isEdit  =  false

      if(popUpMode == 'EDIT'){
          const taxationId = singleTaxationDetails?.id
          trimmedValues.isEdit  = true
          trimmedValues.id   = taxationId
      }
      console.log("submitted values ->", trimmedValues);
      handleAddEditTaxations(trimmedValues);
      setSuccessMessage("");
    },
  });

  // Function handle sub product add functionality
  async function handleAddEditTaxations(values) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }

      let response = await handleAddEditTaxationApi(values, authToken);
      if (response?.code == 200) {
            // if(values.isEdit && appSettings.tax_id == values.id){
            //   setAppSettings((prev)=>({...prev,tax_value : values.value}))
            // }
            setErrorMessage("");
            setSuccessMessage(response.message);
            fetchAllTaxations(authToken);
            setTaxationModal(false);
      } else {
            setSuccessMessage("");
            setErrorMessage(response?.message || "");
      }
    } catch (error) {
      console.log(error.message);
      setSuccessMessage("");
      setErrorMessage("Something went wrong");
    }
  }

  // Function for fetch all taxations
  async function fetchAllTaxations() {
    try {
      let response = await getAllTaxationDetailsApi(authToken);
      if (response?.code == 200) {
            setTaxations(response?.data || []);
      }
    } catch (err) {
      console.log("err->", err.message);
    }
  }

    // Function for change products status 
    const handleChangeTaxationStatus = async(distId) =>{
      try{
  
        let response = await handleChangeTaxationStatusApi(distId, authToken);
        if (response?.code == 200) {
              const updatedTaxations = taxations?.map((item)=>
              distId == item.id ?  {...item,status : item.status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'} : item)
              setTaxations(updatedTaxations);
        } 
      }catch(error){
          console.log("error",error);
      }
    }

  // Function for fetch single  distributor details based on the distributor id 
  const fetchSingleTaxationDetails= async(taxationId) =>{
    try{
      if (!authToken) {
        throw new Error("Token not found.");
      }
      let response = await fetchSingleTaxationsDetailsApi(authToken, taxationId);
      if (response?.code == 200) {
        toggle();
        setSingleTaxationDetails(response?.data || []);
      }
      setPopUpMode("EDIT");
    
    }catch(err){
      console.log("err",err.message);
    }
  }

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title={appName} breadcrumbItem="Taxations" />
        <Row>
          <Col lg={12}>
            <Card>
              <CardHeader tag="h5" className="p-1 ">
                <Button color="success" onClick={toggle}>
                  Add Tax
                </Button>
              </CardHeader>
              <OpenPopUp
                taxationModal={taxationModal}
                toggle={toggle}
                taxationForm={taxationForm}
                errorMessage={errorMessage}
                successMessage={successMessage}
                popUpMode={popUpMode}
              />
              <CardBody>
                <Table striped className="w-75 " style={{margin : '0 auto'}}>
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Name</th>
                      <th >Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {taxations?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.name.toUpperCase()}</td>
                        <td >
                           <Button color={`${item.status == 'ACTIVE' ? 'success' : 'danger'}`} type="button" onClick={()=>{handleChangeTaxationStatus(item.id)}}>
                            {item.status}
                          </Button>
                        </td>
                        <td>
                        <Button  color={`success`} type="button" onClick={()=>{fetchSingleTaxationDetails(item.id)}}>
                            Edit
                          </Button>
                        </td>
                       </tr>
                     ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Taxations;

const OpenPopUp = ({
  taxationModal,
  toggle,
  taxationForm,
  errorMessage,
  successMessage,
  popUpMode
}) => {
  return (
    <div>
      <Modal size="md" isOpen={taxationModal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{ popUpMode !== 'EDIT' ? 'Add Tax' : 'Edit Tax'}</ModalHeader>
        <Form onSubmit={taxationForm.handleSubmit}>
          <ModalBody>
            <Row className="d-flex justify-content-center">
              <Col md={12}>
                {errorMessage && (
                  <span className=" invalidError d-flex justify-content-center">
                    {errorMessage}
                  </span>
                )}
                {successMessage && (
                  <span className=" successMsg d-flex justify-content-center">
                    {successMessage}
                  </span>
                )}
              </Col>
              <Col md={8}>
                <FormGroup>
                  <Label htmlFor="taxation_name">Name:</Label>
                  <Input
                    type="text"
                    value={taxationForm.values.name}
                    required
                    onChange={taxationForm.handleChange}
                    id="taxation_name"
                    name="name"
                  />
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary">
              Submit
            </Button>
            {/* </FormGroup> */}
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

